import { render, staticRenderFns } from "./Multiparts.vue?vue&type=template&id=501a25e5&scoped=true&"
import script from "./Multiparts.vue?vue&type=script&lang=js&"
export * from "./Multiparts.vue?vue&type=script&lang=js&"
import style0 from "./Multiparts.vue?vue&type=style&index=0&id=501a25e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501a25e5",
  null
  
)

export default component.exports